<template>
    <div class="protocol-form-inputs">
        <el-form-item
            :label="
                $t('contrato_rastreabilidade.messages.protocol.protocol_label')
            "
        >
            <el-select
                v-model="data"
                style="width: 100%;"
                :placeholder="
                    $t(
                        'contrato_rastreabilidade.messages.protocol.protocol_placeholder'
                    )
                "
                :disabled="!showComponents"
            >
                <el-option
                    :label="protocol.name"
                    :value="protocol.id"
                    v-for="protocol in protocols"
                    :key="protocol.id"
                >
                    {{ protocol.name }}
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'PropertySelectEs',
    props: {
        value: {
            type: String,
            default: null
        }
    },
    computed: {
        ...mapState('traceabilityContractModule', ['form']),
        ...mapGetters('traceabilityContractModule', {
            protocols: 'getProtocols'
        }),
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        showComponents() {
            return !!this.form.id;
        }
    }
};
</script>

<style scoped lang="scss">
.protocol-form-inputs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 16px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
}

.protocol-form-inputs-opacity {
    opacity: 0.5;
}
</style>
